// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisSearchResponseModel {
    static getAttributeTypeMap() {
        return DiagnosisSearchResponseModel.attributeTypeMap;
    }
}
DiagnosisSearchResponseModel.discriminator = undefined;
DiagnosisSearchResponseModel.additionalProperties = false;
DiagnosisSearchResponseModel.attributeTypeMap = [
    {
        "name": "diagnoses",
        "baseName": "diagnoses",
        "type": "Array<DiagnosisModel>"
    },
];
//# sourceMappingURL=diagnosisSearchResponseModel.js.map